// src/components/MemoLogo.js
import React from 'react';

function MemoLogo({ 
  size = 32, 
  className = '', 
  style = {}, // 新增：接收外部样式
  theme = 'dark' // 可选：'dark' | 'light'，默认'dark'用于深色背景
}) {
  // 定义两套完整的颜色方案
  const colorThemes = {
    light: { // 用于浅色背景
      outerFill: '#24292f',   // 外圈填充 - 深灰
      outerStroke: '#0969da', // 外圈描边 - 蓝色
      innerFill: '#ffffff',   // 内部本子 - 固定白色
      innerStroke: '#57606a', // 内部描边 - 中灰
      cornerFill: '#f6f8fa',  // 折角填充 - 浅灰
      lineStroke: '#6e7781',  // 线条颜色 - 浅灰
    },
    dark: { // 用于深色背景（默认）
      outerFill: '#f0f6fc',   // 外圈填充 - 浅灰蓝
      outerStroke: '#58a6ff', // 外圈描边 - 亮蓝
      innerFill: '#ffffff',   // 内部本子 - 固定白色
      innerStroke: '#c9d1d9', // 内部描边 - 浅灰
      cornerFill: '#161b22',  // 折角填充 - 中灰
      lineStroke: '#8b949e',  // 线条颜色 - 浅灰
    },
  };

  // 根据传入的theme参数选择颜色方案
  const colors = colorThemes[theme] || colorThemes.dark;

  // 基础样式：确保图标作为行内元素且垂直居中
  const baseStyle = {
    display: 'inline-block', // 关键：使其与文字在同一行
    verticalAlign: 'middle', // 关键：与文字垂直居中对齐
  };

  // 合并基础样式和传入的样式（传入的样式优先级更高）
  const combinedStyle = { ...baseStyle, ...style };

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={`memo-logo ${className}`}
      aria-label="MemoHub Logo"
      style={combinedStyle} // 应用合并后的样式
    >
      {/* 圆形外框 */}
      <circle 
        cx="50" 
        cy="50" 
        r="45" 
        fill={colors.outerFill}
        stroke={colors.outerStroke}
        strokeWidth="3"
      />
      
      {/* 内部备忘录图形 - 始终为白色主体 */}
      <g transform="translate(30, 30)">
        {/* 本子主体 */}
        <polygon 
          points="0,0 40,0 40,30 20,30 20,40 0,40" 
          fill={colors.innerFill}
          stroke={colors.innerStroke}
          strokeWidth="2"
        />
        {/* 折角 */}
        <polygon 
          points="20,0 40,0 40,20" 
          fill={colors.cornerFill}
          stroke={colors.innerStroke}
          strokeWidth="2"
        />
        {/* 书写线 */}
        <line x1="8" y1="10" x2="30" y2="10" stroke={colors.lineStroke} strokeWidth="1.5"/>
        <line x1="8" y1="18" x2="30" y2="18" stroke={colors.lineStroke} strokeWidth="1.5"/>
        <line x1="8" y1="26" x2="25" y2="26" stroke={colors.lineStroke} strokeWidth="1.5"/>
      </g>
    </svg>
  );
}

export default MemoLogo;